import { render, staticRenderFns } from "./bulma_mapprops.vue?vue&type=template&id=4b96adda&scoped=true"
import script from "./bulma_mapprops.vue?vue&type=script&lang=js"
export * from "./bulma_mapprops.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b96adda",
  null
  
)

export default component.exports